import http from "@/api/http";

const state = {
    followResp: Object,
}

const mutations = {
    setfollowResp: (state, resp) => {
        state.followResp = resp
    },
}

const actions = {
    requestfollow({commit}, params) {
        let url = '/Account/User/Follow'
        return http.post(url, params).then(res => {
            commit('setfollowResp', res)
        })
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}